import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade UnidadeNegocio */
export class UnidadeNegocioFilter implements Filter {
    situacao: number;
    situacoes: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        this.situacoes?.forEach(situacao => params = params.append('situacao', situacao.toString()));

        return params;
    }

    clear() {
        this.situacao = null;
    }
}

